module.exports = __webpack_public_path__ + "img/ched.e77d01a1.png";